/**
 * Scroll-triggered reveal animations using IntersectionObserver.
 * Add data-scroll-reveal to any element to animate it on scroll.
 * Optional: data-scroll-delay="100" (ms), data-scroll-animation="fade-in-up"
 * Animations: fade-in-up (default), fade-in, slide-in-left, slide-in-right, scale-in
 */
(function () {
  'use strict';

  var ANIMATION_CLASS_PREFIX = 'nb-animate--';
  var VISIBLE_CLASS = 'nb-animate--visible';

  function init() {
    var elements = document.querySelectorAll('[data-scroll-reveal]');
    if (!elements.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var compactViewport = window.matchMedia('(max-width: 989px)').matches;

    // Keep motion subtle by default on small screens and for motion-sensitive users.
    if (reducedMotion || compactViewport) {
      elements.forEach(function (el) {
        el.classList.add(VISIBLE_CLASS);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.dataset.scrollDelay || '0', 10);

            if (delay > 0) {
              setTimeout(function () {
                el.classList.add(VISIBLE_CLASS);
              }, delay);
            } else {
              el.classList.add(VISIBLE_CLASS);
            }

            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      var animation = el.dataset.scrollAnimation || 'fade-in-up';
      el.classList.add(ANIMATION_CLASS_PREFIX + animation);
      observer.observe(el);
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', init);

  /**
   * Mobile carousel scroll indicators.
   * Finds containers with snap-x and [data-carousel-dots], then syncs active dot to scroll position.
   */
  var ACTIVE_DOT_CLASS = 'carousel-dot--active';

  function setActiveDot(dots, index) {
    if (!dots || !dots.length) return;
    for (var j = 0; j < dots.length; j++) {
      if (j === index) {
        dots[j].classList.add(ACTIVE_DOT_CLASS);
      } else {
        dots[j].classList.remove(ACTIVE_DOT_CLASS);
      }
    }
  }

  function initCarouselIndicators() {
    var carousels = document.querySelectorAll('.snap-x');
    carousels.forEach(function (carousel) {
      var dotsContainer = carousel.parentElement.querySelector('[data-carousel-dots]');
      if (!dotsContainer) {
        var sibling = carousel.nextElementSibling;
        while (sibling) {
          if (sibling.classList.contains('md:hidden') && sibling.children.length > 0) {
            dotsContainer = sibling;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
      }
      if (!dotsContainer) return;

      var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.carousel-dot'));
      var items = Array.prototype.slice.call(carousel.children);
      if (!dots.length || !items.length) return;

      setActiveDot(dots, 0);

      carousel.addEventListener('scroll', function () {
        var scrollLeft = carousel.scrollLeft;
        var containerWidth = carousel.offsetWidth;
        var viewCenter = scrollLeft + containerWidth / 2;
        var closestIndex = 0;
        var closestDistance = Infinity;
        items.forEach(function (item, i) {
          var itemCenter = item.offsetLeft + item.offsetWidth / 2;
          var distance = Math.abs(itemCenter - viewCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });
        setActiveDot(dots, closestIndex);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselIndicators);
  } else {
    initCarouselIndicators();
  }
  document.addEventListener('shopify:section:load', initCarouselIndicators);
})();
